import { render } from "./ProfileNotificationBlock.vue?vue&type=template&id=8a9bb902&scoped=true&lang=pug"
import script from "./ProfileNotificationBlock.vue?vue&type=script&lang=js"
export * from "./ProfileNotificationBlock.vue?vue&type=script&lang=js"

import "./ProfileNotificationBlock.vue?vue&type=style&index=0&id=8a9bb902&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9bb902"]])

export default __exports__